/** Date range types to use */
export enum DateRangeTypeEnum {
  /** Dates period (start and end dates) */
  PERIOD = 'PERIOD',
  /** Concrete dates (dates list) */
  DATES = 'DATES',
}
